// src/components/Login.js
import React, { useState } from 'react';
import { login, register } from '../firebaseAuth';
import { TextField, Button, Box, Typography, Paper } from '@mui/material';
import tw from 'twin.macro';
import styled from '@emotion/styled';

// Estilos con twin.macro
const BackgroundContainer = styled.div`
  ${tw`flex items-center justify-center h-screen bg-cover bg-center`}
  background-image: url('https://picsum.photos/1920/1080');
`;

const FormContainer = styled(Paper)`
  ${tw`p-8 max-w-sm w-full`}
  background-color: rgba(255, 255, 255, 0.9);
`;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isRegistering) {
        await register(email, password);
        alert('Usuario registrado correctamente');
      } else {
        await login(email, password);
        alert('Inicio de sesión exitoso');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <BackgroundContainer>
      <FormContainer elevation={6}>
        <Typography variant="h4" align="center" gutterBottom>
          {isRegistering ? 'Registrarse' : 'Iniciar sesión'}
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          {error && <Typography color="error">{error}</Typography>}
          <Box mt={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
            >
              {isRegistering ? 'Registrarse' : 'Iniciar sesión'}
            </Button>
          </Box>
        </form>
        {/* <Box mt={2} textAlign="center">
          <Button
            onClick={() => setIsRegistering(!isRegistering)}
            color="secondary"
          >
            {isRegistering
              ? '¿Ya tienes cuenta? Inicia sesión'
              : 'Crear cuenta nueva'}
          </Button>
        </Box> */}
      </FormContainer>
    </BackgroundContainer>
  );
};

export default Login;
